import React from 'react';
import { GlobalStyles } from '@mui/material';

export default (
    <GlobalStyles
        styles={`
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 100;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Thin.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Thin.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: italic;
        font-weight: 100;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-ThinItalic.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-ThinItalic.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 200;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-ExtraLight.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-ExtraLight.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: italic;
        font-weight: 200;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-ExtraLightItalic.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-ExtraLightItalic.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 300;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Light.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Light.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: italic;
        font-weight: 300;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-LightItalic.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-LightItalic.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Regular.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Regular.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: italic;
        font-weight: 400;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Italic.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Italic.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Medium.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Medium.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: italic;
        font-weight: 500;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-MediumItalic.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-MediumItalic.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter-SemiBold';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-SemiBold.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-SemiBold.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: italic;
        font-weight: 600;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-SemiBoldItalic.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-SemiBoldItalic.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Bold.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Bold.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: italic;
        font-weight: 700;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-BoldItalic.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-BoldItalic.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 800;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-ExtraBold.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-ExtraBold.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: italic;
        font-weight: 800;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-ExtraBoldItalic.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-ExtraBoldItalic.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 900;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Black.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-Black.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter';
        font-style: italic;
        font-weight: 900;
        font-display: swap;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-BlackItalic.woff2') format('woff2'),
             url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web%20hinted%20latin)/Inter-BlackItalic.woff') format('woff');
      }
      @font-face {
        font-family: 'Inter var';
        font-weight: 100 900;
        font-display: swap;
        font-style: normal;
        font-named-instance: 'Regular';
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web)/Inter-roman.var.woff2') format('woff2');
      }
      @font-face {
        font-family: 'Inter var';
        font-weight: 100 900;
        font-display: swap;
        font-style: italic;
        font-named-instance: 'Italic';
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web)/Inter-italic.var.woff2') format('woff2');
      }
      @font-face {
        font-family: 'Inter var experimental';
        font-weight: 100 900;
        font-display: swap;
        font-style: oblique 0deg 10deg;
        src: url('https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.13.0/Inter%20(web)/Inter.var.woff2') format('woff2');
      }
    `}
    />
);
